export const KEY_ENGINE_TYPES = 'engine_type';
export const KEY_FITTING_CODES = 'fitting_codes'; // AKA variants
export const KEY_COLOUR_TEMPERATURE = 'colour_temperature';
export const KEY_DRIVERS = 'drivers';
export const KEY_BEAM_ANGLES = 'beam_angles';
export const KEY_BEZEL_COLOURS = 'bezel_colours';
export const KEY_BAFFLE_COLOURS = 'baffle_colours';
export const KEY_BARREL_ROD = 'barrel_rod';
export const KEY_OPTIONS = 'options';
